/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 9cd7be8f9e15
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

/**
 * Valid field names for selective resource responses.
 */
export const ResourceFieldsEnum = {
  PublicId: "public_id",
  AssetId: "asset_id",
  AssetFolder: "asset_folder",
  Folder: "folder",
  DisplayName: "display_name",
  Format: "format",
  Version: "version",
  ResourceType: "resource_type",
  Type: "type",
  CreatedAt: "created_at",
  Bytes: "bytes",
  Width: "width",
  Height: "height",
  Backup: "backup",
  AccessControl: "access_control",
  AccessMode: "access_mode",
  Url: "url",
  SecureUrl: "secure_url",
  Tags: "tags",
  Context: "context",
  Metadata: "metadata",
  ModerationKind: "moderation_kind",
  ModerationStatus: "moderation_status",
  Placeholder: "placeholder",
  Regions: "regions",
  IsAudio: "is_audio",
} as const;
/**
 * Valid field names for selective resource responses.
 */
export type ResourceFieldsEnum = ClosedEnum<typeof ResourceFieldsEnum>;

export const ResourceFieldsEnum$zodSchema = z.enum([
  "public_id",
  "asset_id",
  "asset_folder",
  "folder",
  "display_name",
  "format",
  "version",
  "resource_type",
  "type",
  "created_at",
  "bytes",
  "width",
  "height",
  "backup",
  "access_control",
  "access_mode",
  "url",
  "secure_url",
  "tags",
  "context",
  "metadata",
  "moderation_kind",
  "moderation_status",
  "placeholder",
  "regions",
  "is_audio",
]).describe("Valid field names for selective resource responses.");
